module.exports = "/images/vendor/leaflet.fullscreen/icon-fullscreen-2x.png?c2f3405e26373eb8f6bd6c9c68b63f9c";